import React, { useCallback, useState } from 'react';
import { ActionIcon, Box, Tooltip } from '@mantine/core';

/** Props Tooltip partagés — portal + fixed pour échapper au overflow des datatables. */
export const TABLE_ACTION_TOOLTIP_PROPS = {
  withArrow: true,
  withinPortal: true,
  floatingStrategy: 'fixed',
  position: 'top',
  zIndex: 10000,
  openDelay: 0,
  closeDelay: 0,
  transitionProps: { duration: 0 },
  events: { hover: true, focus: false, touch: false },
  middlewares: { flip: true, shift: true, inline: false },
};

/** Cible pour Tooltip Mantine (ref + survol fiables). */
export function TooltipTarget({ children, style, className, ...props }) {
  return (
    <Box
      component="span"
      display="inline-flex"
      className={className}
      style={{ lineHeight: 0, flexShrink: 0, ...style }}
      {...props}
    >
      {children}
    </Box>
  );
}

/**
 * Bouton d'action de datatable avec tooltip Mantine.
 * Mode contrôlé : évite le dismiss automatique au scroll du tableau (Floating UI),
 * qui empêchait les tooltips de rester visibles.
 */
export default function TableActionIcon({
  label,
  tooltipProps,
  onMouseEnter,
  onMouseLeave,
  onFocus,
  onBlur,
  ...props
}) {
  const [opened, setOpened] = useState(false);

  const show = useCallback(
    (event) => {
      setOpened(true);
      onMouseEnter?.(event);
    },
    [onMouseEnter],
  );

  const hide = useCallback(
    (event) => {
      setOpened(false);
      onMouseLeave?.(event);
    },
    [onMouseLeave],
  );

  const showFocus = useCallback(
    (event) => {
      setOpened(true);
      onFocus?.(event);
    },
    [onFocus],
  );

  const hideBlur = useCallback(
    (event) => {
      setOpened(false);
      onBlur?.(event);
    },
    [onBlur],
  );

  if (!label) {
    return <ActionIcon {...props} />;
  }

  return (
    <Tooltip
      label={label}
      opened={opened}
      {...TABLE_ACTION_TOOLTIP_PROPS}
      {...tooltipProps}
    >
      <ActionIcon
        aria-label={label}
        onMouseEnter={show}
        onMouseLeave={hide}
        onFocus={showFocus}
        onBlur={hideBlur}
        {...props}
      />
    </Tooltip>
  );
}

/** Groupe d'actions de ligne de datatable (alignement homogène). */
export function TableActionsGroup({ children }) {
  return (
    <Box component="span" className="jlfc-table-actions" display="inline-flex">
      {children}
    </Box>
  );
}
